import { PageHeader } from "@/components/PageHeader";
import { PeriodControlTab } from "./tabs/PeriodControlTab";

/** Monthly operational work, so it lives under Accounting (ADR-0028 rule 4). */
export function PeriodControlPage() {
  return (
    <div className="flex flex-col gap-4">
      <PageHeader title="Period control" />
      <PeriodControlTab />
    </div>
  );
}
